import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthProvider";
import { MainCouranteProvider } from "./contexts/MainCouranteProvider";
import { ToastProvider } from "./contexts/ToastContext";
import MainCourantePopup from "./components/MainCourantePopup";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <ToastProvider>
          <MainCouranteProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <AppRoutes />
              <MainCourantePopup />
            </BrowserRouter>
          </MainCouranteProvider>
        </ToastProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
